import React, { useMemo, useState, useEffect, useRef } from "react";
import { fetchListOfService } from "../../Services/ServiceDocumentation/ServiceDoct";
import PlanCard from "../../Components/ServicesComponent/PlanCard";
import TestimonialCard from "../../Components/ServicesComponent/TestimonialCard";
import PopupModal from "../../Components/PopupModal";
import {
  DivTag,
  HeadTag,
  InputField,
  PTag,
  TextArea,
  Button,
  FormTag,
} from "../../Components/Tags/Tags";
import { IoMdClose } from "react-icons/io";
import Header from "../../Components/Header";
import { logDOM } from "@testing-library/react";
import { X } from "lucide-react";

const ServicePage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("all");
  const [category, setCategory] = useState([]);
  const [baclkupCategory, setBackupCategory] = useState([]);
  const [filterCategory, setFilterCategory] = useState([]);
  const [categorySearch, setCategorySearch] = useState("");
  const [typedText, setTypedText] = useState("");
  const [showServiceList, setShowServiceList] = useState(false);
  const [showCategoryList, setShowCategoryList] = useState(false);

  useMemo(() => {
    const retrieveServiceData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchListOfService();

        const services = response?.data || [];
        setServiceData(services);
        setFilteredData(services);

        const uniqueCategories = [
          ...new Set(
            services.map((s) => s.service_category_name).filter(Boolean),
          ),
        ];

        setCategory(uniqueCategories);
        setBackupCategory(uniqueCategories);
        setFilterCategory(uniqueCategories);

        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching service data:", error);
        setIsLoading(false);
      }
    };
    retrieveServiceData();
  }, []);

  useEffect(() => {
    let filtered = serviceData;

    if (searchTerm.trim() !== "") {
      filtered = filtered.filter((service) =>
        service?.service_name?.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    }

    if (categorySearch.trim() !== "") {
      filtered = filtered.filter((service) =>
        service?.service_category_name
          ?.toLowerCase()
          .includes(categorySearch.toLowerCase()),
      );
    }

    if (statusFilter === "active") {
      filtered = filtered.filter((s) => s.assigned === true);
    } else if (statusFilter === "inactive") {
      filtered = filtered.filter((s) => s.assigned === false);
    }

    setFilteredData(filtered);
  }, [searchTerm, categorySearch, statusFilter, serviceData]);

  const handleOpenModal = () => setIsOpen(true);

  const handleCloseModal = () => {
    setIsOpen(false);
    setIsSubmitted(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitted(true);
  };

  const typingTexts = [
    "BankA/CVerification",
    "Credit Score Verification Equifax",
    "Server2 Experian Credit Score",
    "Experian Credit Report API",
    "Credit Score Verification Equifax",
    "Equifax Credit Score Check API",
    "GST Advance",
    "UDYAM Advance",
    "Mobile Number Account Detection",
    "mobile-number-validation(Srv2)",
    "mobile-upi-lookup/basic(Srv2)",
  ];

  useEffect(() => {
    let index = 0;
    let charIndex = 0;
    let isDeleting = false;
    let currentText = typingTexts[index];
    const typingSpeed = 120;
    const erasingSpeed = 60;
    const delayBetween = 1500;

    const type = () => {
      if (!isDeleting) {
        // typing forward
        setTypedText(currentText.substring(0, charIndex + 1));
        charIndex++;
        if (charIndex === currentText.length) {
          isDeleting = true;
          setTimeout(type, delayBetween);
        } else {
          setTimeout(type, typingSpeed);
        }
      } else {
        // erasing backward
        setTypedText(currentText.substring(0, charIndex - 1));
        charIndex--;
        if (charIndex === 0) {
          isDeleting = false;
          index = (index + 1) % typingTexts.length;
          currentText = typingTexts[index];
          setTimeout(type, typingSpeed);
        } else {
          setTimeout(type, erasingSpeed);
        }
      }
    };

    const timeoutId = setTimeout(type, typingSpeed);
    return () => clearTimeout(timeoutId);
  }, []);

  const groupedServices = category
    .map((cat) => ({
      category: cat,
      services: filteredData.filter(
        (service) => service.service_category_name === cat,
      ),
    }))
    .filter((group) => group.services.length > 0);

  useEffect(() => {
    if (categorySearch === "") setFilterCategory(baclkupCategory);

    const target = categorySearch?.toLowerCase()?.trim();

    const match = baclkupCategory?.filter((item, idx) => {
      return item?.toLowerCase().includes(target);
    });
    setFilterCategory(match);
  }, [categorySearch]);

  return (
    <>
      <PopupModal isOpen={isOpen} onClose={handleCloseModal}>
        <DivTag className="flex justify-end relative overflow-auto">
          <Button
            className="bg-red-600 hover:bg-blue-500 rounded-lg text-white"
            onClick={handleCloseModal}
            icons={<IoMdClose size={24} />}
          />
        </DivTag>

        {isSubmitted ? (
          <PTag
            className="text-blue-500 font-bold text-xl p-5"
            text="Service activation request Successfully submitted"
          />
        ) : (
          <FormTag onSubmit={handleSubmit}>
            <HeadTag
              className="text-xl font-bold mb-2 text-center"
              text="Activation Request"
            />
            <InputField
              type="text"
              id="domain_name"
              name="domain_name"
              placeholder="Domain Name"
              className="w-full p-2 mt-2 mb-4 border border-blue-700 rounded-md"
              onChange={() => {}}
            />
            <TextArea
              id="api_use_case"
              name="api_use_case"
              placeholder="API Use Case"
              className="w-full p-2 mb-4 border border-blue-700 rounded-md"
              value=""
              onChange={() => {}}
            />
            <DivTag className="flex justify-center">
              <Button
                type="submit"
                text="Submit"
                className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 text-md hover:from-blue-900 hover:to-blue-400"
                id="Submit"
                name="Submit"
              />
            </DivTag>
          </FormTag>
        )}
      </PopupModal>

      <Header heading="Service Page" />

      <DivTag className="flex flex-col md:flex-row justify-center items-start gap-4 bg-state-300 overflow-hidden">
        <TestimonialCard />

        <DivTag className="flex flex-col w-full">
          <DivTag className="w-full bg-white p-3 rounded-lg shadow mb-3 flex gap-2">
            <div className="w-full">
              <input
                autoComplete="off"
                onFocus={() => {
                  setShowServiceList(true);
                  setShowCategoryList(false);
                }}
                id="search-input"
                type="search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder={`Search by Service Name... ${typedText}`}
                className="w-full border border-blue-400 rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500 text-gray-700"
              />

              {/* Dropdown Container */}
              {filteredData?.length > 0 && showServiceList && (
                <div className="relative">
                  <div className="absolute top-full left-0 mt-2 w-72 z-30 bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 rounded-xl shadow-xl overflow-hidden animate-in fade-in slide-in-from-top-1 duration-200">
                    {/* Header */}
                    <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-100 dark:border-zinc-800">
                      <h2 className="text-sm font-semibold text-zinc-700 dark:text-zinc-300">
                        Select Service
                      </h2>
                      <button
                        onClick={() => setShowServiceList(false)}
                        className="p-1 rounded-lg text-zinc-400 hover:bg-zinc-100 dark:hover:bg-zinc-800 hover:text-zinc-600 dark:hover:text-zinc-200 transition-colors"
                        aria-label="Close menu"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>

                    {/* Service List Options */}
                    <div className="py-1 max-h-60 overflow-y-auto divide-y divide-zinc-50 dark:divide-zinc-800/50">
                      {filteredData.map((item, idx) => (
                        <button
                          key={item?.id || idx} // Highly recommended to use a unique ID instead of index if available
                          onClick={() => {
                            setSearchTerm(item?.service_name);
                            // setFilters(prev => ({...prev, service_id: item.id}))
                            setShowServiceList(false);
                          }}
                          className="w-full text-left px-4 py-2.5 text-sm text-zinc-600 dark:text-zinc-400 hover:bg-zinc-50 dark:hover:bg-zinc-800/60 hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors block layout-fixed truncate"
                        >
                          {item?.service_name}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="w-full">
              <input
                autoComplete="off"
                onFocus={() => {
                  setShowCategoryList(true);
                  setShowServiceList(false);
                }}
                type="text"
                value={categorySearch}
                onChange={(e) => setCategorySearch(e.target.value)}
                placeholder="Search by Category..."
                className="w-full border border-green-400 rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-green-500 text-gray-700"
              />

              {/* Dropdown Container for category*/}
              {filterCategory?.length > 0 && showCategoryList && (
                <div className="relative">
                  <div className="absolute top-full left-0 mt-2 w-72 z-30 bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 rounded-xl shadow-xl overflow-hidden animate-in fade-in slide-in-from-top-1 duration-200">
                    {/* Header */}
                    <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-100 dark:border-zinc-800">
                      <h2 className="text-sm font-semibold text-zinc-700 dark:text-zinc-300">
                        Select Category
                      </h2>
                      <button
                        onClick={() => setShowCategoryList(false)}
                        className="p-1 rounded-lg text-zinc-400 hover:bg-zinc-100 dark:hover:bg-zinc-800 hover:text-zinc-600 dark:hover:text-zinc-200 transition-colors"
                        aria-label="Close menu"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>

                    {/* category List Options */}
                    <div className="py-1 max-h-60 overflow-y-auto divide-y divide-zinc-50 dark:divide-zinc-800/50">
                      {filterCategory.map((item, idx) => (
                        <button
                          key={idx} // Highly recommended to use a unique ID instead of index if available
                          onClick={() => {
                            setCategorySearch(item);
                            setShowCategoryList(false);
                          }}
                          className="w-full text-left px-4 py-2.5 text-sm text-zinc-600 dark:text-zinc-400 hover:bg-zinc-50 dark:hover:bg-zinc-800/60 hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors block layout-fixed truncate"
                        >
                          {item}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className=" border border-blue-400 rounded-md px-2 py-2 text-gray-700"
            >
              <option value="all">All Services</option>
              <option value="active">Assigned</option>
              <option value="inactive">Not Assigned</option>
            </select>
          </DivTag>

          <DivTag className="flex flex-wrap justify-around items-center bg-blue-50 p-1 rounded-lg shadow-inner mb-1 text-sm sm:text-base">
            <p className="font-semibold text-blue-800">
              Total Services:{" "}
              <span className="text-gray-700 font-bold text-xl">
                {serviceData.length}
              </span>
            </p>
            <p className="font-semibold text-green-700">
              Assigned Services:{" "}
              <span className="text-gray-700 font-bold text-xl">
                {serviceData.filter((s) => s.assigned === true).length}
              </span>
            </p>
            <p className="font-semibold text-red-600">
              Not Assigned Services:{" "}
              <span className="text-gray-700 font-bold text-xl">
                {serviceData.filter((s) => s.assigned === false).length}
              </span>
            </p>
          </DivTag>

          <DivTag className="flex flex-col gap-4 max-h-[36rem] overflow-y-auto px-2 ">
            {isLoading ? (
              <p className="text-center text-gray-500 py-4">
                Loading services...
              </p>
            ) : groupedServices?.length > 0 ? (
              groupedServices?.map((group, i) => (
                <fieldset
                  key={i}
                  className=" border-2 border-gray-500 rounded-md pr-4 "
                >
                  <legend className="px-3 text-xl text-center font-bold text-blue-700">
                    {group?.category}
                  </legend>

                  <div className="grid grid-cols-[repeat(auto-fit,minmax(400px,1fr))] gap-2">
                    {group?.services.length > 0 ? (
                      group?.services.map((service) => (
                        <PlanCard
                          key={service?.service_id}
                          serviceId={service?.service_id}
                          onButtonClick={handleOpenModal}
                          serviceName={service?.service_name}
                          serviceValue={service?.service_value}
                          end_point={service?.end_point}
                          preference={service?.preference}
                          status={service?.status}
                          environment={service?.environment || "-"}
                          isAssigned={service?.assigned}
                          description={service?.key_description}
                        />
                      ))
                    ) : (
                      <p className="text-gray-400 p-1 text-sm">
                        No services in this category
                      </p>
                    )}
                  </div>
                </fieldset>
              ))
            ) : (
              <p className="text-center text-gray-500 py-4">
                No services found
              </p>
            )}
          </DivTag>

          {/* <DivTag
            className="grid grid-cols-[repeat(auto-fit,minmax(400px,1fr))]
            md:gap-2 gap-2 max-h-[33rem] overflow-y-auto md:mt-1 mt-1 px-2"
          >
            {isLoading ? (
              <p className="text-center col-span-full text-gray-500 py-4">
                Loading services...
              </p>
            ) : filteredData.length > 0 ? (
              filteredData.map((service) => (
                <PlanCard
                  key={service?.service_id}
                  serviceId={service?.service_id}
                  onButtonClick={handleOpenModal}
                  serviceName={service?.service_name}
                  serviceValue={service?.service_value}
                  end_point={service?.end_point}
                  preference={service?.preference}
                  status={service?.status}
                  environment={service?.environment || "-"}
                  isAssigned={service?.assigned}
                  description={service?.key_description}
                />
              ))
            ) : (
              <p className="text-center col-span-full text-gray-500 py-4">
                No services found
              </p>
            )}
          </DivTag> */}
        </DivTag>
      </DivTag>
    </>
  );
};

export default ServicePage;
